<se-fe-grid seFeGridOpts="left">
  @for (product of (products$ | async) ?? []; track product.id) {
    <se-fe-grid-cell seFeGridOpts="1/1@mobile 1/2@tablet 1/4@desktop 1/5@hd">
      <app-yso-product
        [item]="product"
        [specificationMap]="(specificationMap$ | async) ?? {}"
        [variantMap]="(variants$ | async) ?? {}"
        (addToCartClick)="addToCart($event)"
        (addClareBundleToCart)="addClareBundle($event)"></app-yso-product>
    </se-fe-grid-cell>
  }
</se-fe-grid>
<app-add-on-footer
  (registerAnotherPersonClick)="registerAnother()"
  (continueToCheckoutClick)="complete()"></app-add-on-footer>
